/**
 *
 * Asynchronously loads the component for Chatbot
 *
 */

import { lazyLoad } from 'utils/loadable';

export const Chatbot = lazyLoad(
  () => import('./index'),
  module => module.Chatbot,
);
